import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Mask a phone number for display. Format: `+91 93******28` — first 2 and
 * last 2 digits after the +91 country prefix are visible, middle 6 digits
 * are asterisked. Falls back to em-dash for empty input.
 * Called from Shared-lead cards, Leads list, Lead detail, etc.
 */
export function maskPhone(raw) {
  if (!raw) return "—";
  const digits = String(raw).replace(/\D/g, "").slice(-10);  // last 10 = local number
  if (digits.length < 10) return `+91 ${digits}`;
  const first2 = digits.slice(0, 2);
  const last2 = digits.slice(-2);
  return `+91 ${first2}******${last2}`;
}
